<div class="dropdown"
     [ngClass]="{'dropdown--right': isFloatRight(), 'dropdown--up': isFloatUp()}"
     (clickOutside)="close()"
     [id]="id"
     #sparkDropDown>
  <ng-content select="dropdown-toggle"></ng-content>

  <div class="dropdown__menu"
       [ngClass]="{'dropdown__menu--show': isOpen }">
    <div class="menu__item"
         *ngFor="let item of items"
         [ngClass]="{'menu__item--selected': isSelected(item)}"
         (click)="onClick(item)">
      <span class="item__label">{{item.label}}</span>
      <span class="item__desc"
            *ngIf="item.description">{{item.description}}</span>
    </div>
  </div>
</div>